import React from 'react';
import PropTypes from 'prop-types';

import './module.css';

const renderData = data => {
  if (typeof data === 'string' || typeof data === 'number') {
    return <li>{data}</li>;
  }

  return Object.keys(data).map(key => {
    if (key === 'link') {
      return <li>{data[key]}</li>;  // eslint-disable-line
    }

    return <li key={key}>{key}: {data[key]}</li>;
  });
};

// eslint-disable-next-line react/no-multi-comp
const SummaryBarItem = ({
  title,
  data,
  iconClassName,
  colClassName,
  number
}) => (
  <div styleName="item" className={`col-xs-12 ${colClassName}`}>
    <i styleName="icon" className={iconClassName} alt="" />
    <div styleName="content">
      {number && <h4 styleName="title">{number}</h4>}
      {title && <span styleName="title">{title}</span>}
      <ul styleName="list">
        {renderData(data)}
      </ul>
    </div>
  </div>
);

SummaryBarItem.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  number: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  iconClassName: PropTypes.string,
  colClassName: PropTypes.string,
  data: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string
  ])
};

export default SummaryBarItem;
